import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

export function SidebarListSkeleton({
  rows = 6,
  dense = false,
  className,
}: {
  rows?: number
  dense?: boolean
  className?: string
}) {
  return (
    <div className={cn('flex flex-col', className)}>
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className={cn(
            'border-b border-border px-3',
            dense ? 'py-1.5' : 'py-2.5',
          )}
        >
          <Skeleton className={cn('h-3 w-[75%]', dense && 'h-2.5')} />
          {!dense ? <Skeleton className="h-2 w-1/3 mt-2" /> : null}
        </div>
      ))}
    </div>
  )
}
